import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

import ModalVideo from 'react-modal-video'
import { useDispatch, useSelector } from 'react-redux'
import { mediaModelAction, vdrMediaDataAction } from '../../../redux/actions/VdrAction'
import ReactPlayer from 'react-player'
import VideoThumbnail from 'react-video-thumbnail';
import $ from 'jquery';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import axios from 'axios'




function get_vimeo_thumbnail(url, imgId, size = null, callback = null) {

    axios.get(`https://vasudeep.com:8084/https://player.vimeo.com/video/${url[0]}/config?h=${url[1]}`)
        .then(function (response) {
            var data = response.data;
            $(`#${imgId}`).attr('src', data.video.thumbs.base)
            $(`#title${url[0]}`).text(data.video?.title)
        })
        .catch(function (error) {

            // console.log(error);
        });
}
// function get_vimeo_thumbnail(url, imgId, size = null, callback = null) {

//     var result;
//     if (result = url.match(/vimeo\.com.*[\\\/](\d+)/)) {
//         var video_id = result.pop();
//         if (size == 'small') {
//             var video_link = encodeURIComponent("https://vimeo.com/" + video_id + "?width=480&height=360");
//             $.getJSON('https://vimeo.com/api/oembed.json?url=' + video_link, function (data) {
//                 if (data && data.thumbnail_url) {
//                     if (typeof (callback) !== 'undefined') {
//                         callback(data.thumbnail_url);
//                     }
//                 }
//             });
//         }
//         else {
//             $.getJSON('https://vimeo.com/api/v2/video/' + video_id + '.json', function (data) {
//                 if (data) {
//                     // if (typeof (callback) !== 'undefined') {
//                     var thumbnail_src = data[0].thumbnail_large;
//                     $('#' + imgId).attr('src', thumbnail_src);
//                     return true;
//                     if (thumbnail_src) {
//                         return thumbnail_src;
//                     }
//                     // }
//                 } else {
//                     return false
//                 }
//             });
//         }
//     }
// }

const MediaSection = (props) => {
    const { CompanyID } = props;

    const dispatch = useDispatch();
    const { data, loading } = useSelector(state => state.vdrMediaDataReducer);
    useEffect(() => {
        dispatch(vdrMediaDataAction([
            {
                "CompanyID": CompanyID,
                "userid": 1,
                "videoCode": "",
                "videoId": "",
                "videoType": "",
                "videoTitle": "",
                "videoDescription": "",
                "DocumentType": "",
                "SectorID": "",
                "IndustryID": []
            }
        ]))
    }, [dispatch]);

    return (
        <>
            <Grid container spacing={2}
                className='mediaContainer'>
                {
                    data &&
                        data.Data?.length ?
                        <>
                            {
                                data.Data.map((item) => {
                                    var VideoThumbnail1;
                                    var vCode = item.videoCode ? item.videoCode.split('/') : [];
                                    if (item.videoType === 'vimeo') {
                                         console.log(vCode);
                                        VideoThumbnail1 = get_vimeo_thumbnail(vCode, `imgId${vCode[0]}`);
                                    } else {
                                        VideoThumbnail1 = `https://img.youtube.com/vi/${item.videoCode}/mqdefault.jpg`;
                                    }
                                    if (item.videoCode != '' && VideoThumbnail1 != '') {

                                        return (
                                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                                <>
                                                    <Box

                                                        sx={{
                                                            position: 'relative',
                                                        }}
                                                        className='mediaItemBox' onClick={() => dispatch(mediaModelAction({ isOpen: true, type: item.videoType, itemId: item.videoCode }))}>
                                                        <img
                                                            className='mediaItem'
                                                            id={`imgId${vCode[0]}`}
                                                            src={VideoThumbnail1}
                                                        />
                                                        <Box
                                                            sx={{
                                                                position: 'absolute',
                                                                backgroundColor: '#00000080',
                                                                width: '100%',
                                                                height: '100%',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                            }}>
                                                            <PlayCircleOutlineIcon sx={{ color: '#fff', fontSize: 70 }} />
                                                        </Box>
                                                    </Box>
                                                </>
                                            </Grid>
                                        )
                                    }
                                })
                            }
                        </>
                        :
                        <>
                            <Typography variant='h6' fontSize={18} marginLeft={2} marginTop={2}>
                                Videos Coming Soon
                            </Typography>
                        </>
                }

            </Grid>
        </>
    )
}

export default MediaSection